import {
    DELETE_API_KEY_SUCCESS,
    CLEAR_API_KEY_TOKEN,
    CREATE_API_KEY_SUCCESS,
    FETCH_API_KEYS,
    FETCH_API_KEYS_FAILURE,
    FETCH_API_KEYS_SUCCESS,
    API_KEY_LIST_PAGE,
    API_KEY_LIST_SORT,
    FETCH_API_KEY,
    FETCH_API_KEY_SUCCESS,
    UPDATE_API_KEY_SUCCESS,
    SORT_DESC,
} from 'store/actions/types';
import paginationHelper from 'helpers/pagination';
import reducerHelper from 'helpers/reducers';
import utils from 'helpers/utils';

const initialState = {
    created: {},
    data: {},
    ids: [],
    field: 'name',
    loading: false,
    offset: 0,
    order: SORT_DESC,
    page: 1,
    size: 24,
    total: 0,
};

export default function apiKeys(state = initialState, action) {
    switch (action.type) {
        case CLEAR_API_KEY_TOKEN:
            return Object.assign({}, state, {
                created: {},
            });

        case CREATE_API_KEY_SUCCESS:
            return Object.assign({}, state, {
                data: Object.assign({}, state.data, { [action.response.id]: {
                    created_at: action.response.created_at,
                    id: action.response.id,
                    last_used_at: null,
                    name: action.response.name,
                    user_id: action.response.user_id,
                } }),
                created: {
                    name: action.response.name,
                    token: action.response.token,
                },
                ids: [
                    ...state.ids,
                    ...action.response.id,
                ],
                loading: false,
            });

        case FETCH_API_KEY:
        case FETCH_API_KEYS:
            return Object.assign({}, state, {
                loading: true,
            });

        case FETCH_API_KEYS_FAILURE:
            return Object.assign({}, state, {
                data: {},
                token: {},
                ids: [],
                loading: false,
                offset: 0,
                size: 0,
                total: 0,
            });

        case FETCH_API_KEY_SUCCESS:
            return Object.assign({}, state, {
                data: Object.assign({}, state.data, { [action.payload.id]: action.payload }),
                ids: [
                    ...state.ids,
                    ...action.payload.id,
                ],
                loading: false,
            });

        case FETCH_API_KEYS_SUCCESS:
            // Converts the Array of results to an Object based on the id.
            const convertResultsToData = utils.mapToObject(action.payload.results, (value) => {
                return value.id;
            });

            const newIds = action.payload.results.map(function (result) {
                return result.id;
            });

            return Object.assign({}, state, {
                data: Object.assign({}, state.data, convertResultsToData),
                ids: newIds,
                loading: false,
                offset: action.payload.offset,
                size: action.payload.size,
                total: parseInt(action.payload.total, 10),
            });

        case API_KEY_LIST_PAGE:
            return Object.assign({}, state, {
                offset: paginationHelper.generateNewOffset(action.payload.page, state.size),
                page: action.payload.page,
            });

        case API_KEY_LIST_SORT:
            return Object.assign({}, state, {
                field: action.payload.field,
                order: action.payload.order,
            });

        case UPDATE_API_KEY_SUCCESS:
            return Object.assign({}, state, {
                data: Object.assign({}, state.data, {
                    [action.response.id]: {
                        id: action.response.id,
                        name: action.response.name,
                        created_at: action.response.created_at,
                        last_used_at: action.response.last_used_at,
                        user_id: action.response.user_id,
                    },
                }),
                loading: false,
            });

        case DELETE_API_KEY_SUCCESS:
            const { id } = action.payload;

            const deletedData = reducerHelper.removeItemFromObject(state.data, id);
            const deletedStateIds = reducerHelper.removeItemFromArrayOfStrings(state.ids, id);

            return Object.assign({}, state, {
                data: deletedData,
                ids: deletedStateIds,
                loading: false,
                total: state.total - 1,
            });

        default:
            return state;
    }
}



// WEBPACK FOOTER //
// ./src/store/reducers/apiKeysReducer.js